import React, { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import * as S from './PaymentAgreementText.styles';
import { ROUTES } from '@/constants/routes';
import { CustomLink } from '@/components/CustomLink/CustomLink';

interface Props {
  className?: string;
  buttonName?: string;
}

export const PaymentAgreementText: FC<Props> = ({ className, buttonName }) => {
  const { t } = useTranslation();
  return (
    <S.Text className={className}>
      <Trans
        i18nKey="pages.ad.agree_gdpr_policy"
        components={{
          link1: <CustomLink target="_blank" href={ROUTES.terms} />,
          link2: <CustomLink target="_blank" href={ROUTES.proposal} />,
        }}
        values={{ buttonName: buttonName ?? t('common.pay') }}
      />
    </S.Text>
  );
};
